import React from 'react'
import styled from 'styled-components'
import PureSelect from '../pure-select.component'
import { connect } from 'react-redux'
import { StyledCardFields } from '../payment-fields/styled-card-fields.style'
import { MuvicardInput, PasswordInput } from '../inputs.component'
import { breakpoints } from '../../../constants'
import { getMuvicardInstallmentOptions } from '../../../modules/private/client/ticket-sale/muvicard-installment-options'
import { mapApiInstallments } from '../../../helpers'
import { CheckboxToggleInput } from './../../../components/form-components/inputs.component'
import { maskHelper } from '../../../helpers/mask.helper'
import { Creators as MuvicardPurchaseCreators } from '../../../ducks/muvicard-purchase/muvicard-purchase'
import MuvicardPurchaseSelectors from '../../../ducks/muvicard-purchase/muvicard-purchase.selectors'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'

const StyledFieldsContainer = styled.div`
	margin-bottom: 3rem;

	.one-click-container {
		grid-column: 1 / -1;
		display: flex;
		flex-direction: row-reverse;
		width: max-content;
		justify-content: space-between;
		align-items: center;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-column: auto;
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			.one-click-container {
				width: 80%;
			}
		}

		@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
			.one-click-container {
				width: 95%;
			}
		}
	}

	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.one-click-container {
			width: 95%;
		}
	}
	#select-activateOneClickMuvicard {
		margin-right: 10px;
	}
	.one-click-info {
		font-weight: bold;
	}
`
class MuvicardFields extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isGettingMuvicardInstallmentsOptions: false,
			fetchedMuvicardInstallmentOptions: false,
		}
	}

	componentWillUnmount() {
		this.props.setInstallmentsOptions([])
		this.props.setInstallmentsQtt(1)
	}

	async fetchInstallmentOptions(orderValue) {
		const {
			installmentsQtt,
			apiInstallments,
			apiPaymentMethodsLoading,
			disableLegacyInstallments,
			user,
		} = this.props

		if (apiPaymentMethodsLoading) return

		const hasPublicBody = user && user.hasPublicBody

		if (!apiInstallments && disableLegacyInstallments) {
			// Checkout novo: payments/methods do carrinho e fonte unica - sem
			// fallback pro endpoint legado.
			this.props.setInstallmentsOptions([])
			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: true,
			})
			return
		}

		if (apiInstallments) {
			const options = mapApiInstallments(apiInstallments, orderValue)
			this.props.setInstallmentsOptions(options)

			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: true,
			})

			if (hasPublicBody && options.length) {
				this.selectFirstInstallment(options[0].value)
			} else if (installmentsQtt) {
				this.setInterestValue(installmentsQtt)
			}

			return
		}

		try {
			this.setState({ isGettingMuvicardInstallmentsOptions: true })

			const muvicardInstallmentsOptions =
				await getMuvicardInstallmentOptions(orderValue)

			// Superada por uma busca mais nova (keep latest): ela é quem atualiza a tela.
			if (muvicardInstallmentsOptions === null) return

			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: true,
			})

			if (muvicardInstallmentsOptions) {
				this.props.setInstallmentsOptions(muvicardInstallmentsOptions)
			}

			if (hasPublicBody && muvicardInstallmentsOptions && muvicardInstallmentsOptions.length) {
				this.selectFirstInstallment(muvicardInstallmentsOptions[0].value)
			} else if (installmentsQtt) {
				this.setInterestValue(installmentsQtt)
			}
		} catch (error) {
			this.setState({
				isGettingMuvicardInstallmentsOptions: false,
				fetchedMuvicardInstallmentOptions: false,
			})
		}
	}

	// Usuário PublicBody só tem 1 opção de parcelamento disponível (ver
	// slice(0, 1) no render) - vem pré-selecionada, sem exigir que o usuário
	// abra o select pra escolher a única opção existente.
	selectFirstInstallment(value) {
		this.props.setFieldValue('installments', value)
		this.props.setInstallmentsQtt(value)
		this.setInterestValue(value)
	}

	async componentDidMount() {
		if (!this.state.fetchedMuvicardInstallmentOptions) {
			await this.fetchInstallmentOptions(this.props.orderValue)
		}
	}

	async componentDidUpdate(prevProps) {
		if (
			prevProps.orderValue !== this.props.orderValue ||
			prevProps.apiInstallments !== this.props.apiInstallments ||
			prevProps.apiPaymentMethodsLoading !== this.props.apiPaymentMethodsLoading
		) {
			await this.fetchInstallmentOptions(this.props.orderValue)
		}
	}

	handleCompleteCpfField = () => {
		const { onCompleteCpf, values } = this.props
		if (values && values.muvicardCpf) {
			onCompleteCpf(maskHelper.onlyNumbers(values.muvicardCpf))
		}
	}

	setInterestValue(installment) {
		this.props.setInterestRate(installment)
	}

	renderMuvicardInput = () => {
		return (
			<MuvicardInput
				{...this.props}
				id="muvicardCpf"
				className="cardNumber"
				label="CPF"
				onComplete={this.handleCompleteCpfField}
			/>
		)
	}

	renderMuvicardPassword = () => {
		return (
			<PasswordInput
				{...this.props}
				id="password"
				label="Senha do Muvicard (4 Dígitos)"
				maxLength={4}
				onlyNumbers
			/>
		)
	}

	renderMuvicardInstallments = (installmentsOptions) => {
		const { isCalculatingValues } = this.props

		let noInstallmentsMessage =
			'Valor de parcela incompatível para compra no cartão Muvicard'

		const fetchingInstallmentOptions =
			!installmentsOptions.length ||
			isCalculatingValues ||
			this.state.isGettingMuvicardInstallmentsOptions

		return (
			<PureSelect
				{...this.props}
				id="installments"
				label="Parcelamento"
				className="installments"
				placeholder={
					fetchingInstallmentOptions ? 'Calculando...' : 'Selecione...'
				}
				options={installmentsOptions}
				handleChange={(e) => {
					const installment = e.target.value

					if (installment) {
						this.props.setInstallmentsQtt(installment)
						this.setInterestValue(installment)
					}

					return this.props.handleChange(e)
				}}
				noOptionsMessage={noInstallmentsMessage}
				disabled={fetchingInstallmentOptions}
			/>
		)
	}

	render() {
		const { touched, submitCount, user, installmentsOptions } = this.props

		let installments = installmentsOptions

		if (user && user.hasPublicBody) {
			installments = installmentsOptions.slice(0, 1)
		}

		return (
			<React.Fragment>
				<p className="blue">Informações do cartão Muvicard</p>
				<StyledFieldsContainer>
					<StyledCardFields>{this.renderMuvicardInput()}</StyledCardFields>
					<StyledCardFields>
						{this.renderMuvicardPassword()}
					</StyledCardFields>
					{submitCount > 0 && !touched.password ? (
						<span
							className="error"
							style={{
								color: '#CC4F4F',
								fontSize: '16px',
								display: 'block',
								marginTop: '-35px',
							}}>
							Informe a sua senha
						</span>
					) : (
						''
					)}

					<StyledCardFields>
						{this.renderMuvicardInstallments(installments)}
					</StyledCardFields>

					{user !== null ? (
						<React.Fragment>
							<CheckboxToggleInput
								label="Ativar compras com 1 clique Muvicard"
								id="activateOneClickMuvicard"
								className="one-click-container"
								{...this.props}
							/>
							<div className="one-click-info">
								Ao ativar a compra com 1 clique Muvicard, você está
								ciente que não será necessário a digitação de
								informações na próxima compra!
							</div>
						</React.Fragment>
					) : null}
				</StyledFieldsContainer>
			</React.Fragment>
		)
	}
}

const mapStateToProps = (store) => ({
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	installmentsOptions:
		MuvicardPurchaseSelectors.getMuvicardInstallmentsOptions(
			store.muvicardPurchase
		),
	installmentsQtt: MuvicardPurchaseSelectors.getMuvicardInstallmentsQtt(
		store.muvicardPurchase
	),
})

const mapDispatchToProps = {
	setInstallmentsQtt: MuvicardPurchaseCreators.setMuvicardInstallmentsQtt,
	setInterestRate: MuvicardPurchaseCreators.setMuvicardInterestRate,
	setInstallmentsOptions:
		MuvicardPurchaseCreators.setMuvicardInstallmentsOptions,
}

export default connect(mapStateToProps, mapDispatchToProps)(MuvicardFields)
